import { lazy } from 'react';
import { createBrowserRouter } from 'react-router';

const NotFound = lazy(() => import('./pages/NotFound'));
const Introduction = lazy(() => import('./pages/Introduction'));
const SasanoArutoki = lazy(() => import('./pages/@sasano_arutoki'));
const HisanoUsata = lazy(() => import('./pages/@hisano_usata'));
const YuFanLuvJoe = lazy(() => import('./pages/@yu_fan_luv_joe'));
const Tuokemao = lazy(() => import('./pages/@tuokemao'));
const Yushanz55 = lazy(() => import('./pages/@yushanz_55'));
const PatrickKuo = lazy(() => import('./pages/@PatrickKuo'));
const Jacoblin = lazy(() => import('./pages/@jacoblin__'));
const Mori = lazy(() => import('./pages/@Mori'));

export const router = createBrowserRouter([
  {
    index: true,
    Component: Introduction,
  },
  {
    path: '/@sasano_arutoki',
    Component: SasanoArutoki,
  },
  {
    path: '/@hisano_usata',
    Component: HisanoUsata,
  },
  {
    path: '/@yu_fan_luv_joe',
    Component: YuFanLuvJoe,
  },
  {
    path: '/@tuokemao',
    Component: Tuokemao,
  },
  {
    path: '/@yushanz_55',
    Component: Yushanz55,
  },
  {
    path: '/@PatrickKuo',
    Component: PatrickKuo,
  },
  {
    path: '/@jacoblin__',
    Component: Jacoblin,
  },
  {
    path: '/@Mori',
    Component: Mori,
  },
  {
    path: '*',
    Component: NotFound,
  },
]);
